import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProductsService } from '../services/products.service';
import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-add-doors-windows',
  templateUrl: './add-doors-windows.component.html',
  styleUrls: ['./add-doors-windows.component.scss']
})
export class AddDoorsWindowsComponent implements OnInit {
  @Output() step1Editer = new EventEmitter();

  doorsAndWindows: any[] = [];
  apiUrl: string = environment.apiUrl;

  getItemTitle(item): string {
    return item.left_menu_alias || item.description || '';
  }

  getItemImageUrl(item): string {
    if (item.localProductImg) {
      return item.localProductImg;
    }
    if (item.localAsset && item.productImg) {
      return `/assets/images/doors_windows/generic/${item.productImg}`;
    }
    return `${this.apiUrl}/containers/images/download/${item.productImg}`;
  }

  constructor(
    private productsService: ProductsService,
    private objectAddService: ObjectAddService
  ) {}

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  itemClick(item): void {
    this.objectAddService.setEntity(item);
  }

  remove() {
    this.objectAddService.remove();
  }

  ngOnInit() {
    this.productsService.getDoorsAndWindows().then(dw => {
      this.doorsAndWindows = dw;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/add-doors-windows/add-doors-windows.component.ts